module.exports = __webpack_public_path__ + "img/Dash_share.bcbd166a.svg";